import React, { useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router';
import { Auth } from 'aws-amplify';
import { useDispatch } from 'redux-react-hook';
import helpers from '../../utils/helpers';
import LoginService from '../Login/services/Login.service';
import * as UserAction from '../../store/user/actions';
import AlertActions from '../../store/alert/actions';
import { localStorageHas, localStorageSet, localStorageClean, setCookie } from '../../utils/storage';
const PrivateRoute = (props: any) => {
  const { component: Component, ...rest } = props;
  const isAuthenticated: boolean = localStorageHas('tkn') && localStorageHas('tkn_user');
  const dispatch = useDispatch();

  const boundShowError = () => {
    dispatch(AlertActions.danger({
      message: "No pudimos validar tus datos.",
      description: 'Por favor, inténtalo nuevamente.'
    }))
  };

  useEffect(() => {
    Auth.currentSession()
      .then(async (res: any) => {
        const { idToken = {} } = res;
        const { payload } = idToken;
        const user = payload;

        const roles = payload['cognito:groups'];
        const lessOneRol = helpers.lessOneRol(roles);
        if (lessOneRol.length === 0) {
          await Auth.signOut();
          localStorageClean();
        }

        localStorageSet('tkn', idToken.jwtToken);

        const trace = {
          serviceId: 'API-OBT-USUARIO',
        };
        const params = {
          iderol: ["1", "2", "3", "4", "5", "6"],
          email: user.email,
          rolCognito: lessOneRol[0],
          rolDescripcion: lessOneRol[0] === process.env.REACT_APP_ROL_ASESOR ? "ASESOR" : null
        };
        const request = helpers.generarRequest(params, trace);
        LoginService.postObtUsuario(request).then((response) => {
          if (response.response.status.success && response.response.payload.length > 0) {
            localStorageSet('rimac_user_info', response.response.payload[0]);
            localStorageSet('tkn_user', user);
            dispatch(UserAction.set(user))
          } else {
            boundShowError();

            setTimeout(() => {
              AlertActions.remove();
              Auth.signOut();
              console.log("El usuario logueado no es un emisor");
            }, 2500);
          }
        }).catch((err) => {
          boundShowError();
          setTimeout(() => {
            AlertActions.remove();
            Auth.signOut();
            console.log('error obt usuario');
          }, 2500);
          //await Auth.signOut();
          //console.log('error obt usuario');
          throw err;
        }).finally(() => {
        })
      })
      .catch(async err => {
        await Auth.signOut();
        console.error('After login -> ' + err);
      })
  }, [])

  return (
    <Route
      {...rest}
      render={props => (
        isAuthenticated ? (
          <Component {...props} parent={rest.parent} />
        ) : (
            <div>
              <Redirect push to="/" />
            </div>
          )
      )} />
  )
}

export default PrivateRoute;
